import { Component, inject, input } from '@angular/core';
import { Svg3Component } from './svg/svg-3.component';
import { ChartService } from 'src/app/services/chart/chart.service';
import { Router } from '@angular/router';
import { Path, RoutePath } from 'src/app/shared/route';
import { AuthService } from 'src/app/services/auth/auth.service';
import deepDiff from 'deep-diff';
import { isChart } from 'src/app/shared/utils';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './final.component.html',
  standalone: true,
  selector: 'app-onboarding-final',
  imports: [Svg3Component, MatButtonModule, TranslatePipe],
  styles: `
    button[mat-flat-button] {
      --mdc-filled-button-container-height: 50px;
    }
    button[mat-button] {
      --mdc-text-button-container-height: 50px;
      --mdc-text-button-label-text-color: rgb(var(--color-text-6));
    }
  `,
})
export class FinalComponent {
  private readonly chartService = inject(ChartService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  readonly productId = input<string | undefined>(undefined);

  readonly DashboardRoute = RoutePath.getPath(Path['dashboard']).fullPath;

  private _finish$() {
    return this.authService.updateProfile({
      diffs: deepDiff({ finishedOnboarding: false }, { finishedOnboarding: true }) ?? [],
    });
  }

  onViewChart() {
    this._finish$().subscribe(() => {
      const chart = this.chartService.chart;

      if (chart) {
        const productId = this.productId();

        if (productId) {
          this.router.navigate(RoutePath.getPath(Path['products/:id']).generate({ id: productId }));
          return;
        }

        if (isChart(chart)) this.router.navigate(RoutePath.getPath(Path['charts/:id']).generate({ id: chart._id }));
        else this.router.navigate(RoutePath.getPath(Path['table-chart/:id']).generate({ id: chart._id }));
      } else this.router.navigate(this.DashboardRoute);
    });
  }

  onNavigateToDashboard() {
    this._finish$().subscribe(() => {
      this.router.navigate(this.DashboardRoute);
    });
  }
}
